import { Constant } from '@shared/interfaces/constant';
import { Observable } from 'rxjs';

export const CONSTANTS_REPOSITORY = 'Constants';

export interface ConstantsRepository {
  url: string;

  getItems(): Observable<any>;

  edit(constant: Constant): Observable<any>;
}
